import iso8601 from "iso8601-duration";
import { datesAreSameDay, WEEK_DAYS } from "./date.js";
const TIMEUNITS_NO = {
  hour: ["time", "r"],
  minute: ["minutt", "er"],
  second: ["sekund", "er"]
};
function parseDuration(duration) {
  if (isDuration(duration)) {
    return duration;
  } else if (duration instanceof Date) {
    return {
      hours: duration.getHours(),
      minutes: duration.getMinutes(),
      seconds: duration.getSeconds()
    };
  } else if (typeof duration === "number") {
    duration = Math.abs(duration);
    return {
      hours: Math.floor(duration / 3600),
      minutes: Math.floor(duration / 60 % 60),
      seconds: Math.floor(duration % 60)
    };
  } else if (typeof duration === "string") {
    return iso8601.parse(duration);
  } else {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
}
function formatDuration(duration) {
  if (!isDuration(duration)) {
    duration = parseDuration(duration);
  }
  const { hours = 0, minutes = 0, seconds = 0 } = duration;
  const mmss = `${pad(minutes)}:${pad(seconds)}`;
  return hours > 0 ? `${pad(hours)}:${mmss}` : mmss;
}
function durationToSeconds(duration) {
  if (!isDuration(duration)) {
    duration = parseDuration(duration);
  }
  return iso8601.toSeconds(duration);
}
function durationToReadableString(duration) {
  duration = parseDuration(duration);
  const { hours = 0, minutes = 0, seconds = 0 } = duration;
  if (!hours && !minutes && !seconds) {
    return "0 sekunder";
  }
  const hoursText = timeUnitToReadableString("hour", hours);
  const minutesText = timeUnitToReadableString("minute", minutes);
  const secondsText = !hours && timeUnitToReadableString("second", seconds);
  return [hoursText, minutesText, secondsText].filter(Boolean).join(" og ");
}
function dateToReadableString(date) {
  if (typeof date.getHours !== "function") {
    return "";
  }
  return `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}.${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}.${date.getFullYear()}, ${dateToReadableTimeString(date)}`;
}
function dateToReadableDateString(date) {
  if (typeof date.getHours !== "function") {
    return "";
  }
  return `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}.${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}.${date.getFullYear()}`;
}
function dateToReadableShortString(date1, date2) {
  const dateIsToday = datesAreSameDay(date1, date2);
  if (dateIsToday) {
    return `${dateToReadableTimeString(date1)}`;
  }
  const daysBetween = Math.abs(date2.getTime() - date1.getTime()) / 1e3 / 60 / 60 / 24;
  if (daysBetween < 5) {
    return WEEK_DAYS[date1.getDay()] + ` ${dateToReadableTimeString(date1)}`;
  }
  return dateToReadableString(date1);
}
function dateToReadableTimeString(date) {
  if (typeof date.getHours !== "function") {
    return "";
  }
  const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  return `${hours}:${minutes}`;
}
function timeUnitToReadableString(unit, time) {
  if (time === 0) {
    return;
  }
  const [noun, plural] = TIMEUNITS_NO[unit];
  return `${time} ${noun}${time !== 1 ? plural : ""}`;
}
function isDuration(duration) {
  return duration != null && typeof duration === "object" && ("hours" in duration || "minutes" in duration || "seconds" in duration);
}
function pad(num) {
  return num < 10 ? `0${num}` : String(num);
}
export {
  dateToReadableDateString,
  dateToReadableShortString,
  dateToReadableString,
  dateToReadableTimeString,
  durationToReadableString,
  durationToSeconds,
  formatDuration,
  parseDuration
};
